
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: "FreightRateTableTemplateRoutesBlock",

  components: {
    TableCityPrices: () => import("~/components/routes/TableCityPrices"),
    MobileTableCityPrices: () => import("~/components/routes/MobileTableCityPrices.vue"),
  },

  computed: {
    price_1_5_tonn: function () {
      return this.cityInfo?.price_1_5 || 0
    },
    price_3_5_tonn: function () {
      return this.cityInfo?.price_3 || 0
    },
    price_5_tonn: function () {
      return this.cityInfo?.price_5 || 0
    },
    price_10_tonn: function () {
      return this.cityInfo?.price_10 || 0
    },
    price_20_tonn: function () {
      return this.cityInfo?.price_20 || 0
    },

    rows: function () {
      return [
        ['Тент', this.multipleFactor(this.price_1_5_tonn, 1), this.multipleFactor(this.price_3_5_tonn, 1), this.multipleFactor(this.price_5_tonn, 1), this.multipleFactor(this.price_10_tonn, 1), this.multipleFactor(this.price_20_tonn, 1)],
        ['Борт', this.multipleFactor(this.price_1_5_tonn, 2), this.multipleFactor(this.price_3_5_tonn, 2), this.multipleFactor(this.price_5_tonn, 2), this.multipleFactor(this.price_10_tonn, 2), this.multipleFactor(this.price_20_tonn, 2)],
        ['Фургон *', this.multipleFactor(this.price_1_5_tonn, 3), this.multipleFactor(this.price_3_5_tonn, 3), this.multipleFactor(this.price_5_tonn, 3), this.multipleFactor(this.price_10_tonn, 3), this.multipleFactor(this.price_20_tonn, 3)],
        ['Изотермический *', this.multipleFactor(this.price_1_5_tonn, 4), this.multipleFactor(this.price_3_5_tonn, 4), this.multipleFactor(this.price_5_tonn, 4), this.multipleFactor(this.price_10_tonn, 4), this.multipleFactor(this.price_20_tonn, 4)],
        ['Рефрижератор *', this.multipleFactor(this.price_1_5_tonn, 5), this.multipleFactor(this.price_3_5_tonn, 5), this.multipleFactor(this.price_5_tonn, 5), this.multipleFactor(this.price_10_tonn, 5), this.multipleFactor(this.price_20_tonn, 5)],
      ]
    },

    cityInfo: function () {
      return this.externalData?.FreightRateTableTemplateRoutesBlock?.cityInfo || {}
    },

    anotationMessage: function () {
      return this.$store.state?.appState?.vars?.['Публичная оферта страниц маршрутов'] || "";
    }
  },

  methods: {
    multipleFactor: function (value, factor) {
      const number = value + (value * Number.parseFloat(process.env.FREIGHT_PRICE_MULTIPLE || '0.1')) * factor;
      return `${this.$numberFormat(number)} руб.`
    }
  }
});
